module.exports = __webpack_public_path__ + "static/media/add.3fab68ee.svg";